<template>
  <div
    class="modal fade"
    id="profile"
    tabindex="-1"
    aria-hidden="true"
    role="dialog"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content shadow-gold">
        <div class="modal-body">
          <h3 class="mb-2">ข้อมูลบัญชี</h3>
          <div class="position-absolute end-0 top-0 p-2 z-index-1 ">
            <button
              type="button"
              class=" btn btn-sm btn-26 roudned-circle shadow-sm shadow-danger text-white bg-danger"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <hr />
          <div class="px-5">
            <div class="card shadow-sm shadow-purple bg-dc mb-3">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-auto align-self-center">
                    <figure class="text-center avatar-50 avatar image-shadow">
                      <img
                        :style="{
                          'background-color': getBankColorwithCode(
                            UserInfo.BankCode
                          ),
                          padding:
                            UserInfo.BankCode == 'co.th.truemoney.wallet'
                              ? ''
                              : '5px',
                        }"
                        v-bind:src="getBankImgwithCode(UserInfo.BankCode)"
                        alt=""
                      />
                    </figure>
                  </div>
                  <div class="col align-self-center text-end">
                    <p class="small">
                      <span class="text-muted size-13">บัญชี</span>
                      <br />
                      <span class="">
                        {{ getBankName(UserInfo.BankCode) }}
                      </span>
                    </p>
                  </div>
                </div>
                <h6 class="fw-normal mb-3">
                  {{ UserInfo.BankAccount | formatAccNo }}
                </h6>
                <div class="row">
                  <div class="col text-end">
                    <p class="mb-0 text-muted size-13">ชื่อบัญชี</p>
                    <p>{{ UserInfo.userName.fullName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-body p-0">
                  <ul class="list-group list-group-flush bg-none">
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-auto">
                          <div
                            class="avatar avatar-44 shadow-sm border-0 card rounded-15"
                          >
                            <img
                              src="/static/img/icon/success.png"
                              alt=""
                              class="img-fluid mx-auto"
                            />
                          </div>
                        </div>
                        <div class="col align-self-center ps-0">
                          <p>UserID</p>
                        </div>
                        <div class="col align-self-center text-end">
                          <p>{{ UserInfo.PhoneNumber }}</p>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-auto">
                          <div
                            class="avatar avatar-44 shadow-sm border-0 card rounded-15"
                          >
                            <img
                              src="/static/img/icon/businessman.png"
                              alt=""
                              class="img-fluid mx-auto"
                            />
                          </div>
                        </div>
                        <div class="col align-self-center ps-0">
                          <p>ชื่อนามสกุล</p>
                        </div>
                        <div class="col align-self-center text-end">
                          <p>{{ UserInfo.userName.fullName }}</p>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-auto">
                          <div
                            class="avatar avatar-44 shadow-sm border-0 card rounded-15"
                          >
                            <img
                              src="/static/img/icon/smartphone.png"
                              alt=""
                              class="img-fluid mx-auto"
                            />
                          </div>
                        </div>
                        <div class="col align-self-center ps-0">
                          <p>เบอร์โทร</p>
                        </div>
                        <div class="col align-self-center text-end">
                          <p>{{ UserInfo.PhoneNumber }}</p>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-auto">
                          <div
                            class="avatar avatar-44 shadow-sm border-0 card rounded-15"
                          >
                            <img
                              src="/static/img/icon/profits.png"
                              alt=""
                              class="img-fluid mx-auto"
                            />
                          </div>
                        </div>
                        <div class="col-auto align-self-center ps-0">
                          <p>ลิงค์แนะนำ</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col text-truncate py-2">
                          <div class="card card-bg-dc">
                            <div
                              class="card-body py-dc px-0 mx-3"
                              style="overflow-x: auto; -webkit-overflow-scrolling: touch;"
                            >
                              <span class="float-left text-muted">
                                {{ affiliateLink }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="col-auto ps-0 py-2">
                          <a
                            href="javascript:void(0)"
                            class="copy-to-clipboard"
                            @click="copyAF(affiliateLink)"
                          >
                            <div
                              class="card bg-dc border-0 shadow-sm shadow-purple"
                            >
                              <div class="card-body p-0">
                                <p class="size-15 px-3 py-dc text-white-copy">
                                  คัดลอก
                                </p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { fetchAffiliate, WithdrawAffiliate } from "@/services/modules/af.js";
import MemberCard from "@/components/form/MemberCard";
import { fetchBonus } from "@/services/modules/promotion.js";
import api from "@/services/index.js";

export default {
  name: "ProfileForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      amount: "",
      bonusName: "-",
      promotionList: [],
      affiliateLink: "",
    };
  },
  components: {
    MemberCard,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPrefix",
    ]),
  },
  methods: {
    ...mapActions(["userSignOut"]),
    async SignOut() {
      await this.userSignOut();
    },
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copybank(item) {
      this.$copyText(item, this.$refs.withdraw);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },

    async copyAF(item) {
      this.$copyText(item, this.$refs.af);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchAffiliate() {
      await fetchAffiliate((res) => {
        if (res.status) {
          this.income = res.data.balance;
          this.Trans = res.data.transaction;
          this.Users = res.data.Users;
          this.TransIncome = res.data.transaction_incomes;
          this.setting = res.data.setting;
        }
      });
    },

    async WithdrawAffiliate() {
      await WithdrawAffiliate((res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },

    async PromotionData() {
      // this.setLoading(true)
      await fetchBonus((res) => {
        if (res.status) {
          this.promotionList = res.data;
        } else {
        }
      });
    },
    async getUserRefresh(Loading) {
      await api
        .get("/auth-service/v1/refresh")
        .then((v) => {
          if (this.UserInfo.BonusInfo.isBonus) {
            if (this.promotionList.length > 0) {
              let promotionItem = this.promotionList.find(
                (x) => x._id === this.UserInfo.BonusInfo.bonusId
              );
              if (promotionItem != undefined) {
                this.bonusName = promotionItem.title;
              } else {
                this.bonusName = "-";
              }
            }
          }
        })
        .catch((e) => {
          this.$swal.fire(e.message, "", "error");
        })
        .finally(() => {});
    },
  },
  async mounted() {
    await this.PromotionData();
    await this.fetchAffiliate();
    this.affiliateLink = "";
    this.affiliateLink =
      window.location.origin + "/" + this.UserInfo.affiliateKey;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/ProfileForm.vue